class Dropdown {
    private menu: HTMLElement;
    private buttons: NodeListOf<HTMLElement>;

    constructor(private dropdown: HTMLElement) {
        this.menu = this.dropdown?.querySelector('.menu-wrapper > .menu')!;
        this.buttons = document.querySelectorAll<HTMLElement>('.dropdown-toggle');

        this.init();
    }

    private init() {
        this.buttons.forEach((button: HTMLElement) => {
            button.addEventListener('click', () => {
                this.dropdown.classList.contains('show') ? this.close() : this.open();
            });
        });

        this.subMenus();
    }

    private subMenus() {
        const items = this.menu?.querySelectorAll<HTMLElement>(':scope > .menu-item-has-children');

        items?.forEach((item: HTMLElement) => {
            const link = item.querySelector<HTMLElement>(':scope > a');
            const submenu = item.querySelector<HTMLElement>(':scope > .sub-menu');

            if (submenu) {
                link?.addEventListener('click', (e: Event) => {
                    if (!submenu.classList.contains('show')) {
                        e.preventDefault();
                    }

                    submenu.classList.toggle('show');

                    items.forEach((otherItem: HTMLElement) => {
                        if (otherItem !== item) {
                            otherItem.querySelector<HTMLElement>(':scope > .sub-menu')?.classList.remove('show');
                        }
                    })
                });
            }
        });
    }

    close() {
        this.dropdown.classList.remove('show');
    }

    open() {
        this.dropdown.classList.add('show');
    }
}

window.addEventListener('load', () => {
    const dropdown = document.querySelector<HTMLElement>('.dropdown');

    if (!dropdown) return;

    new Dropdown(dropdown);
})